export default "__VITE_ASSET__GNEB$N3J__"